<template>
  <div>
    <b-card id="cardLogin" class="scale-in-bl">
      <b-form @submit="onSubmit" @reset="onReset" v-if="show" id="formLogin">
        <h1 class="text-center mb-3">Register</h1>
        <span class="text-center mb-4 other-account"
          >Create your own account</span
        >
        <b-form-group id="input-group-1" label-for="email">
          <b-form-input
            id="email"
            class="input"
            v-model="form.email"
            type="email"
            placeholder="E-mail"
            required
          ></b-form-input>
        </b-form-group>

        <b-form-group id="input-group-2" label-for="input-2">
          <b-form-input
            id="passord"
            class="input"
            v-model="form.password"
            placeholder="Password"
            type="password"
            required
          ></b-form-input>
          <small v-if="!passwordIsValid" class="text-danger"
            >Password must be at least 6 characters long</small
          >
        </b-form-group>

        <b-form-group id="input-group-3" label-for="confirmPassword">
          <b-form-input
            id="confirmPassword"
            class="input"
            v-model="form.confirmPassword"
            placeholder="Confirm Password"
            type="password"
            required
          ></b-form-input>
          <small v-if="!passwordsMatch" class="text-danger"
            >Passwords do not match</small
          >
        </b-form-group>

        <div class="d-flex justify-content-center">
          <b-form-input
            id="firstName"
            class="input"
            v-model="form.firstName"
            placeholder="First Name"
            type="text"
            required
          ></b-form-input>
          <b-form-input
            id="lastName"
            class="input"
            v-model="form.lastName"
            placeholder="Last Name"
            type="text"
            required
          ></b-form-input>
        </div>
        <div class="d-flex justify-content-start">
          <div>
            <span>Role: </span
            ><b-dropdown id="dropdown-1" :text="form.role" class="m-md-2">
              <b-dropdown-item
                v-for="(n, idx) in roles"
                :key="idx"
                @click="form.role = n"
                >{{ n }}</b-dropdown-item
              >
            </b-dropdown>
          </div>
        </div>

        <div class="d-flex justify-content-start flex-wrap">
          <b-form-checkbox value="remember" class="remember"
            >I have read and agree with the terms of use</b-form-checkbox
          >
        </div>

        <div class="d-flex justify-content-center mt-3">
          <b-button
            :disabled="!passwordIsValid || !passwordsMatch || loading"
            type="submit"
            variant="primary"
            class="btn-login"
          >
            Register
          </b-button>
          <b-spinner v-if="loading" type="grow" variant="primary"></b-spinner>
        </div>

        <!-- Success/Failure Message -->
        <div v-if="errMsg" class="d-flex justify-content-center mt-3 error-box">
          <span class="error-msg">{{ errMsg }}</span>
        </div>
        <div
          v-if="successMsg"
          class="d-flex justify-content-center mt-3 success-box"
        >
          <span class="success-msg">{{ successMsg }}</span>
        </div>

        <div class="d-flex justify-content-center flex-wrap mt-4 register">
          <span class="mr-2">Already have an account?</span>
          <a @click="$router.go(-1)" class="loginAccount">Login</a>
        </div>
      </b-form>
    </b-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import * as login_types from "../../store/types_login";
import axios from "axios";

const types = { ...login_types };
export default {
  data() {
    return {
      form: {
        email: "",
        password: "",
        confirmPassword: "",
        firstName: "",
        lastName: "",
        role: "Librarian",
        activationCode: "",
        active: false,
      },
      roles: ["Librarian"],
      show: true,
      loading: false,
      errMsg: null,
      successMsg: null,
    };
  },
  computed: {
    passwordIsValid() {
      return this.form.password.length >= 6;
    },
    passwordsMatch() {
      return this.form.password === this.form.confirmPassword;
    },
  },
  watch: {},
  methods: {
    onSubmit(event) {
      event.preventDefault();
      this.loading = true;
      this.$store.dispatch("login/register", this.form).then(
        (res) => {
          this.loading = false;
          if (res) {
            this.successMsg =
              "An email has been sent to your email address. Please check your email to activate your account before logging in.";
            this.errMsg = "";
            setTimeout(() => {
              this.$router.push("login");
            }, 5000); // 5 seconds delay
          }
        },
        (err) => {
          this.loading = false;
          this.errMsg = err;
        }
      );
    },
    onReset(event) {
      event.preventDefault();
      // Reset our form values
      this.form.email = "";
      this.form.name = "";
      this.form.food = null;
      this.form.checked = [];
      // Trick to reset/clear native browser form validation state
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
  },
};
</script>

<style>
.error-msg {
  color: red;
  font-size: 12px;
  font-weight: bold;
}
.is-valid {
  border-color: green;
}

.is-invalid {
  border-color: red;
  font-size: 12px;
}
.success-msg {
  color: green;
  font-size: 12px;
  font-weight: bold;
}

.success-box {
  background-color: lightgreen;
  padding: 15px;
  border-radius: 5px;
}

.error-box {
  background-color: lightcoral;
  padding: 15px;
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/login/FormRegister.vue